import React, { useState, useEffect } from "react";
import { poCount, finalizePO, cancelPO, allPOs, getPOsForSubsite, currentFilter, setFilter, oosError, finalizeStatus, latestPOId } from '../../reducers/purchaseorder';
import { getOrdersForSubsite, allOrders, orderCount } from '../../reducers/orders';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import MSMPagination from '../MSMPagination';
import { useLocation } from "react-router-dom";
import AdminService from "../../services/admin.service";
import PurchaseOrderService from "../../services/purchaseorder.service";
import DecoratorService from "../../services/decorator.service";
import { Container, Row, Col } from 'react-bootstrap';

const AdminClosedPO = () => {
  const location = useLocation();
  const pos = useSelector(allPOs);
  const poCnt = useSelector(poCount);
  const poStatus = useSelector(state => state.purchaseorders.status);
  const currentFlt = useSelector(currentFilter);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState(0);
  const [resetPagination, setResetPagination] = useState(false);
  const orderStatus = useSelector(state => state.orders.status);
  const finalStatus = useSelector(finalizeStatus);
  const latestPO = useSelector(latestPOId);  
  const orderCnt = useSelector(orderCount);
  const oos = useSelector(oosError);
  const [link, setLink] = useState(null);
  const [showLinkButton, setShowLinkButton] = useState(false);
  const [activeDecoratorId, setActiveDecoratorId] = useState(0);

  const [orders, setOrders] = useState([]);
  const [decorators, setDecorators] = useState([]);

  useEffect(() => {
    console.log("LOADING CLOSED POS");
    async function fetchData() {
      var response = await PurchaseOrderService.getClosedPurchaseOrders();
      console.log("CLOSED POS ---", response.data);
      setOrders(response.data);
      const decorators = await DecoratorService.getDecorators();
      setDecorators(decorators);
      setActiveDecoratorId(decorators[0].id);
    }
    fetchData();
  }, []);
  
  const cancelOrderClick = () => {
    dispatch(cancelPO(cancelOrderId));
    setShow(false);
  }

  const finalizeOrderClick = (event, poId) => {
    event.target.disabled = true;

    dispatch(finalizePO(poId));
  }

  const filterChanged = (event) => {
    console.log(event.target.value);
    setFilter(event.target.value);
    setResetPagination(!resetPagination);
  }

  const reloadData = async(range) => {
    var response = await PurchaseOrderService.getApprovedOrders();
    setOrders(response.data);
  //const params = [ finalized, range[0], range[1] ];
    //dispatch(getPOsForSubsite(params));
  }
  
  const setDecorator = (event) => {
    setActiveDecoratorId(event.target.value);
  }

  const finalizePo = (id) => {
    console.log("Getting XLS Report");
    dispatch(finalizePO({id: id, decoratorId: activeDecoratorId}));
    setLink("http://localhost:5000/api/admin/purchaseorder/report/" + id);
  }
  const handleClose = () => setShow(false);

  const downloadPO = async (id) => {
    console.log("Downloading PO");
    var status = await AdminService.downloadPO(id);
  }
  var orderContent = [];
  return (
    <>
    <h1>Purchase Orders</h1>
    {showLinkButton && <Button onClick={() => downloadPO(latestPO)}>Download PO</Button>}
    {orders && orders.map(order => (
        <>
        <Container   className="user-data">
            <Row>
                <Col className="title" xs={3}>
                    PO ID:
                </Col>
                <Col className="value">
                    {order.id}
                </Col>
            </Row>
            <Row>
            <Col className="title" xs={3}>
            Download PO XLS
                </Col>
                <Col className="value">
                    <Button onClick={() => downloadPO(order.id)}>Download</Button>
                </Col>
            </Row>
            <Row>
            <Col className="title" xs={3}>
            Created On:
                </Col>
                <Col className="value">
                    {new Date(order.createdAt).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) }
                </Col>
            </Row>
            <Row>
            <Col className="title" xs={3}>
            Finalized By:
                </Col>
                <Col className="value">
                    {order.finalizedBy.lastname + ", " + order.finalizedBy.firstname}
                </Col>
            </Row>
            <Row>
            <Col className="title" xs={3}>
            Sanmar Prelfight:
                </Col>
                <Col className="value">
                    Date: {order.preflightDate}<br/>
                    Status: {order.preflightStatus}
                    <Button onClick={() => finalizePo(order.id)}>Send Sanmar Preflight</Button>
                </Col>
            </Row>
            <Row>
            <Col className="title" xs={3}>
            Sent To Sanmar:
                </Col>
                <Col className="value">
                    Date: {order.sentToSanmarDate}<br/>
                    Status: {order.preflightStatus}
                    <Button onClick={() => finalizePo(order.id)}>Send To Sanmar</Button>
                </Col>
            </Row>
        </Container>
        </>
    ))}

    {orders.length == 0 && (
        <div>No Orders</div>
    )
    }
    
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel Order # {cancelOrderId} </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={cancelOrderClick}>
            Cancel the Order
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};
export default AdminClosedPO;

